import React, { FunctionComponent, SyntheticEvent, useEffect, useState } from 'react';
import { Button, Form } from '../../../ui';
import { useBriefMutations, useBriefsOverview } from '../../../../hooks/useBriefs';
import { Brief } from '../../../../services/models/brief';

interface Props {
  active: boolean;
  draftBrief: Brief | null;
}

const SetBriefNameStep: FunctionComponent<Props> = ({ active, draftBrief }) => {
  const { updateBriefName } = useBriefMutations();

  const { briefs: briefItems } = useBriefsOverview();
  const briefs: Brief[] = briefItems || [];

  const [name, setName] = useState(draftBrief?.name);
  const [emptyName, setEmptyName] = useState(false);
  const [duplicatedName, setDuplicatedName] = useState(false);
  const [nameTouched, setNameTouched] = useState(false);

  useEffect(() => {
    if (draftBrief && !name) {
      setName(draftBrief?.name);
    }
    setDuplicatedName(briefs.some(x => x.name === name && x.id !== draftBrief?.id));
    setEmptyName(name?.trim().length === 0);
  }, [name, setDuplicatedName, setEmptyName, duplicatedName, briefs, draftBrief]);

  const save = (event: SyntheticEvent) => {
    event.preventDefault();

    if (draftBrief && name) {
      updateBriefName(draftBrief.id, name);
    }
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNameTouched(true);
    setName(event.target.value);
  };

  if (!active || !draftBrief) {
    return <></>;
  }

  return (
    <div className="mx-auto flex max-w-2xl flex-col items-center py-4">
      <Form onSubmit={e => save(e)} className="w-full max-w-xs">
        <Form.Group className="flex flex-col items-center">
          <Form.Label className="mt-4 text-center">
            <h2 className="text-xl font-bold text-gray-900">Name Your News Brief</h2>
          </Form.Label>
          <Form.Control
            type="text"
            value={name}
            className="mt-4"
            isInvalid={nameTouched && (emptyName || duplicatedName)}
            onChange={(e: any) => handleNameChange(e)}
            placeholder="Enter your news brief title"
          />
          {nameTouched && emptyName && <Form.Text>The name is mandatory</Form.Text>}
          {nameTouched && duplicatedName && (
            <Form.Text>There's already a report with this name</Form.Text>
          )}
          <Button
            className="mt-6"
            type="submit"
            size="lg"
            disabled={draftBrief.isPublishing || emptyName || duplicatedName}
            variant="purple"
          >
            Save
          </Button>
        </Form.Group>
      </Form>
    </div>
  );
};

export default SetBriefNameStep;
